module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle",
    class: [this.state_class],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "draggable",
    style: (_vm.style),
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.dragStart.apply(null, arguments)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5984a191!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/ToggleButton.vue
// module id = 484
// module chunks = 1